<template>
  <div>
    <input
      style="width: 200px"
      type="date"
      ref="input"
      v-model="date"
      v-on:change="onChange"
      v-on:keydown="onKeyDownListener"
      v-on:keyup="onKeyUpListener"
      v-bind:required="question.required"
    />
  </div>
</template>

<script>
import BaseType from "./BaseType.vue";
import { QuestionType } from "../../models/QuestionModel";

export default {
  extends: BaseType,
  name: QuestionType.DropdownDate,
  data() {
    return {
      date: ""
    };
  },
  methods: {
    onKeyDownListener($event) {
      if ($event.key === "ArrowDown" || $event.key === "ArrowUp") {
        this.setAnswer(this.dataValue);
      } else if ($event.key === "Enter" && this.hasValue) {
        this.focused = false;
        this.blur();
      }
    },
    onKeyUpListener($event) {
      if ($event.key === "Enter" && this.isValid()) {
        $event.stopPropagation();
        this._onEnter();
        this.$emit("next");
      }
    },
    dateOptions(start, end) {
      const options = [];
      for (let option = start; option <= end; option++) {
        options.push(option.toString());
      }

      return options;
    },
    onChange() {
      this.dirty = true;
      this.dataValue = this.date;

      this.onKeyDown();
      this.setAnswer(this.dataValue);
    }
  }
};
</script>

<style scoped>
.custom-select {
  position: absolute;
  text-align: center;
  padding: 0 22px;
  font-size: 16px;
  line-height: 80px;
  cursor: pointer;
  height: 100px;
}
</style>
